import { useEffect } from "react";
import { bootstrap, verifyMagicToken, verifyGoogleSession } from "@/soulpath/engine";

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id");
    if (sessionId) {
      window.history.replaceState({}, "", "/");
      verifyGoogleSession(sessionId);
    } else if (window.location.pathname.replace(/\/$/, "") === "/verify" && token) {
      // Clean the URL, then verify the magic-link token and enter the app.
      window.history.replaceState({}, "", "/");
      verifyMagicToken(token);
    } else {
      bootstrap();
    }
  }, []);

  return <div id="sp-app" data-testid="soulpath-root" />;
}

export default App;
